<template>
  <div
    v-if="selectedId"
    class="d-flex align-items-center justify-content-between p-3 border-bottom bg-white"
  >
    <b-input
      v-if="isEditingName"
      v-model="name"
      ref="input"
      @keydown.esc="isEditingName = false"
      @keydown.enter="toggleEditName()"
    />

    <div v-else>
      <h4 class="mb-0">
        {{ selectedGroup.name || userList(selectedGroup.id) }}
      </h4>
      <div v-if="selectedGroup.name">
        {{ userList(selectedGroup.id) }}
      </div>
    </div>

    <b-btn
      v-b-tooltip.hover="'Rename chat'"
      class="ml-3"
      variant="light"
      pill
      @click="toggleEditName()"
    >
      <i :class="isEditingName ? 'icon-check' : 'icon-pencil'" />
    </b-btn>
  </div>
</template>

<script>
import API from "@/api";
import { mapGetters, mapState } from "vuex";

export default {
  data: () => ({
    isEditingName: false,
    name: ""
  }),

  computed: {
    ...mapGetters("chat", ["selectedGroup", "userList"]),
    ...mapState("chat", ["selectedId"])
  },

  methods: {
    renameGroup() {
      const { selectedId, name } = this;
      if (name === this.selectedGroup.name) return;

      API.updateChatGroupName(selectedId, name);
    },

    toggleEditName() {
      if (this.isEditingName) {
        this.renameGroup();
        this.isEditingName = false;
      } else {
        this.name = this.selectedGroup.name;
        this.isEditingName = true;
        this.$nextTick(() => this.$refs.input.focus());
      }
    }
  }
};
</script>
